import React from "react";
import PinnedLottieSection from "../ScrollLottie/PinnedLottieSection";
import { LOTTIE } from "../assets";

export default function TheReality() {
  return (
    <PinnedLottieSection
      eyebrow="THE REALITY"
      heading={
        <>
          <strong>Profitability Governed by Systems</strong>
          <span> Stuck in Past</span>
        </>
      }
      desktopSrc={LOTTIE.scatteredDataDesktop}
      mobileSrc={LOTTIE.scatteredDataMobile}
      ariaLabel="Illustration of operational data arriving from many disconnected sources"
    />
  );
}
